module.exports = __webpack_public_path__ + "static/media/64A2602.c0bb598c.jpg";